<div class="templates-registry-container">
  <!-- Breadcrumb -->
  <nav aria-label="Percorso di navigazione" class="mb-4">
    <p-breadcrumb 
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()" 
      [home]="{icon: 'pi pi-home', routerLink: '/', ariaLabel: 'Home'}">
    </p-breadcrumb>
  </nav>

  <!-- Page Header -->
  <header class="page-header" role="banner">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-cog header-icon" aria-hidden="true"></i>
        <div class="header-text">
          <h1>Registro Template</h1>
          <p class="subtitle">Gestione completa di tutti i template contrattuali</p>
        </div>
      </div>
    </div>
  </header>

  <!-- Reusable Table Component -->
  <app-registry-table
    title="Lista Template"
    icon="pi-cog"
    [columns]="columns"
    [data]="templatesData()"
    [loading]="isLoading()"
    [showClearFiltersButton]="showClearFilters"
    [emptyStateMessage]="emptyMessage()"
    [ignoreStatusChecks]="true"
    [deleteExcludedStatuses]="['ACTIVE']"
    (onDetailClick)="onDetailClick($event)"
    (onEditClick)="onEditClick($event)"
    (onDeleteClick)="onDeleteClick($event)"
    (onDownloadClick)="onDownloadClick($event)"
    (onClearFilters)="onClearFilters()"
  ></app-registry-table>

  <!-- Toast for notifications -->
  <p-toast role="status" aria-live="polite" aria-atomic="true" />
  
  <!-- Confirm Dialog -->
  <p-confirmDialog role="alertdialog" aria-modal="true" />
</div>
